




























































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import tournamentStore from '@/modules/tournament/tournament.store'
import { getModule } from 'vuex-module-decorators'
import AppButton from '@/modules/shared/components/AppButton'
import RegistrationProgress from '@/modules/instant/components/RegistrationProgress'

@Component({
  components: { AppButton, RegistrationProgress }
})
export default class InstantMatchIntroductionDialog extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)

  progressSize: number = 120
  progressWidth: number = 3
  progressRotate: number = 90
  progressColor: string = '#ff00ff'

  get isVisible() {
    return this.tournamentModule.isInstantMatchIntroductionDialogVisible
  }

  set isVisible(value: boolean) {
    this.tournamentModule.setInstantMatchIntroductionDialogVisible(value)
  }

  /* Methods */
  close() {
    this.isVisible = false
    this.$emit('close')
  }
}
